import { GeoJsonProperties } from 'geojson'
import React, { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const Marker = ({
  map,
  latlng,
  children,colorMode="light"
}: {
  map: mapboxgl.Map
  latlng: [number, number]
  children?: JSX.Element[] | JSX.Element | string
  colorMode?:"light"|"dark"
}) => {
  const [position, setPosition] = useState(map.project(latlng))
  const calcPosition = () => setPosition(map.project(latlng))
  const { width } = useWindowSize()

  useEffect(() => {
    
    map.once('idle', calcPosition)
    map.once('move', calcPosition)
    map.once('moveend', calcPosition)
    map.once('zoom', calcPosition)
  }, [width])
  useEffect(() => {
    map.on('idle', calcPosition)
    map.on('move', calcPosition)
    map.on('moveend', calcPosition)
    map.on('zoom', calcPosition)
    return () => {
      map.off('idle', calcPosition)
      map.off('move', calcPosition)
      map.off('moveend', calcPosition)
      map.off('zoom', calcPosition)
    }
  }, [])

  return <_Marker position={position}>{children && children}</_Marker>
}
const _Marker = styled.div<{ position: { x: number; y: number } }>`
  position: absolute;
  top: ${({ position }) => position.y + 'px'};
  left: ${({ position }) => position.x + 'px'};
  transform: translate(-50%, -50%);
`
